import * as ReduxUtils from "../../lib/util/ReduxUtils";
import * as StorageUtils from "../../lib/util/StorageUtils";
import * as PillarDataUtils from "../../lib/util/PillarDataUtils";

import { TIME_RANGE_KEYS } from "../../StorageKeys";

import * as DriverProfileActions from "./DriverProfile.action";

export interface DriverProfileReducerState {
	comparisonLevels: string[];
	timeRange: PillarDataUtils.TimeSelectionId;
	characteristicsTimeRange: PillarDataUtils.TimeSelectionId;
}

const TIME_RANGE_KEY_PILLARS = TIME_RANGE_KEYS.DRIVER_PROFILE_PILLARS;
const TIME_RANGE_KEY_CHARACTERISTICS =
	TIME_RANGE_KEYS.DRIVER_PROFILE_CHARACTERISTICS;

const initialState: DriverProfileReducerState = {
	comparisonLevels: ["target", "user", "group", "root"],
	timeRange:
		StorageUtils.get(TIME_RANGE_KEY_PILLARS) ||
		PillarDataUtils.DEFAULT_TIME_SELECTION.id,
	characteristicsTimeRange:
		StorageUtils.get(TIME_RANGE_KEY_CHARACTERISTICS) ||
		PillarDataUtils.DEFAULT_TIME_SELECTION.id,
};

export default ReduxUtils.composeReducer(initialState, [
	ReduxUtils.createReducerMap({
		[DriverProfileActions.setTimeRange.type]: (state, action) => ({
			...state,
			timeRange: action.payload,
		}),
		[DriverProfileActions.setCharacteristicsTimeRange.type]: (
			state,
			action,
		) => ({
			...state,
			characteristicsTimeRange: action.payload,
		}),
		[DriverProfileActions.setComparisonLevels.type]: (state, action) => ({
			...state,
			comparisonLevels: action.payload,
		}),
	}),
]);
